import { Mui } from '@osu/react-ui';
import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getStudentState} from '../../../../Common/redux/selectors';
import { editTraining as editTrainingAction } from '../../../../services/graphql/slices/applicantActionsSlice';

const EditTrainingDialogContent = () => {
  const dispatch = useDispatch();
  const studentState = useSelector(getStudentState);
  
  const selectedRecommendation = useSelector(
  state => state.editTrainingReducer.editTraining.expectedRecommendation
);
   
  // Get previous expected recommendation from student State
  const previousExpectedRecommendation = studentState?.data?.expectedRecommendation || '';
  
  const committeeButtonMap = studentState?.data?.committeeDetails?.committeeOptions ?? [];
  
  // Handler for changing the expected recommendation
  const handleChangeRecommendation = (expectedRecommendation) => {
    dispatch(editTrainingAction({
      previousExpectedRecommendation,
      expectedRecommendation   
    }));
  };
  const noneIsSelected = selectedRecommendation === 'None';

  return (
    <Mui.Box>
      <Mui.Typography variant="subtitle1" style={{ marginBottom: 8 }}>
       Previous Expected Recommendation:{ ' '}{previousExpectedRecommendation || ''}
      </Mui.Typography>

      <Mui.Typography variant="subtitle1" style={{ marginBottom: 8 }}>
        New Expected Recommendation
      </Mui.Typography>
      <Mui.ButtonGroup aria-label="outlined button group" style={{ marginBottom: 16 }}>
        {committeeButtonMap.map((item, index) => {
           const isSelected = selectedRecommendation === item.value;
          return (
            <Mui.Button
              key={index}
              color={isSelected ? 'secondary' : 'primary'}
              variant={isSelected ? 'contained' : 'outlined'}
              onClick={() => handleChangeRecommendation(item.value)}
            >
              {item.value}
            </Mui.Button>
          );
        })}
        {/* Adding the "None" button since create training allows users to create a training with no expected recommendation*/}
            <Mui.Button
              key="none"
              color={noneIsSelected ? 'secondary' : 'primary'}
              variant={noneIsSelected ? 'contained' : 'outlined'}
              onClick={() => handleChangeRecommendation('None')}
            >
              None
            </Mui.Button>
      </Mui.ButtonGroup>

    </Mui.Box>
  );
};

export default EditTrainingDialogContent;
